import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ControlButton, CONTROL_CONTEXTS } from '../controls';

function WorkspaceGateOverlay({
  active,
  children,
  title = 'Upgrade to SoftwareIQ Core',
  description,
  ctaLabel = 'Upgrade to Core',
  onCtaClick,
  previewLabel,
  onPreviewClick,
  variant = 'fixed',
  width = 'min(720px, 92vw)',
}) {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'relative', flex: '1 1 0', minHeight: 0, height: '100%', maxHeight: '100%', display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
      <Box
        aria-hidden={active || undefined}
        inert={active ? '' : undefined}
        sx={{
          flex: '1 1 0',
          minHeight: 0,
          height: '100%',
          maxHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          filter: active ? 'blur(4px) saturate(0.9)' : 'none',
          transition: 'filter 160ms ease',
          pointerEvents: active ? 'none' : 'auto',
          userSelect: active ? 'none' : 'auto',
        }}
      >
        {children}
      </Box>

      {active && (
        <Box
          sx={{
            position: variant === 'absolute' ? 'absolute' : 'fixed',
            zIndex: 2,
            pointerEvents: 'none',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Box
            sx={{
              width,
              borderRadius: 1,
              backgroundColor: theme.palette.background.paper,
              pointerEvents: 'auto',
              boxShadow: theme.palette.mode === 'dark'
                ? '0 12px 40px rgba(0,0,0,0.5)'
                : '0 12px 40px rgba(0,0,0,0.15)',
              border: theme.palette.mode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.08)',
              p: { xs: 3, sm: 4 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 700, mb: 1 }}>
              {title}
            </Typography>
            {description && (
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, opacity: 0.9, mb: 3 }}>
                {description}
              </Typography>
            )}
            <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', flexWrap: 'wrap' }}>
              {onCtaClick && (
                <ControlButton
                  context={CONTROL_CONTEXTS.FILTER_BAR}
                  buttonVariant="contained"
                  onClick={onCtaClick}
                >
                  {ctaLabel}
                </ControlButton>
              )}
              {onPreviewClick && previewLabel && (
                <ControlButton
                  context={CONTROL_CONTEXTS.FILTER_BAR}
                  buttonVariant="outlined"
                  onClick={onPreviewClick}
                >
                  {previewLabel}
                </ControlButton>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default WorkspaceGateOverlay;
